module.exports = __webpack_public_path__ + "img/guide_5_4.7c84b696.svg";